import React, { useEffect, useState } from "react";
import {
  Alert,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "reactstrap";
import { getCreditNoteOriginCalculation } from "../service";
import { fmtHoverDateTime } from "../../pages/storeSalesDashboardHelpers";

const toErrorText = (err, fallback) => {
  const candidate =
    err?.response?.data?.error?.message ?? err?.message ?? fallback;
  return typeof candidate === "string" ? candidate : fallback;
};

export default function CreditNoteOriginModal({
  isOpen,
  creditNote,
  onClose,
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [origin, setOrigin] = useState(null);

  useEffect(() => {
    if (!isOpen || !creditNote?.id) {
      setOrigin(null);
      setError(null);
      return;
    }

    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const payload = await getCreditNoteOriginCalculation(
          creditNote.id,
          creditNote
        );
        if (!cancelled) setOrigin(payload?.origin ?? null);
      } catch (e) {
        if (!cancelled) {
          setError(toErrorText(e, "Unable to load credit calculation."));
          setOrigin(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isOpen, creditNote]);

  const creditRemarks =
    origin?.credit_remarks ??
    creditNote?.credit_remarks ??
    origin?.origin_summary ??
    null;

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>
        How this credit was calculated
        {origin?.identifier ? (
          <span className="text-muted fw-normal ms-2 small">
            {origin.identifier}
          </span>
        ) : null}
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="py-4 text-center">
            <Spinner />
          </div>
        ) : error ? (
          <Alert color="danger" fade={false} className="mb-0">
            {error}
          </Alert>
        ) : !creditRemarks ? (
          <p className="text-muted mb-0">No credit remarks available.</p>
        ) : (
          <>
            <p className="mb-3 fs-6">{creditRemarks}</p>
            {origin?.issued_at ? (
              <p className="small text-muted mb-0">
                Issued {fmtHoverDateTime(origin.issued_at)}
              </p>
            ) : null}
          </>
        )}
        <div className="d-flex justify-content-end mt-4">
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
}
